var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "choose-id" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.$t("choose_id_explain"))),
      ]),
      _c(
        "div",
        { staticClass: "service-card" },
        [
          _c("div", { staticClass: "pic1" }),
          _c("span", { staticClass: "text1" }, [
            _vm._v(_vm._s(_vm.$t("servicer"))),
          ]),
          _c(
            "span",
            {
              staticClass: "text-style text2",
              attrs: { id: "text2", title: _vm.$t("service_explain") },
            },
            [_vm._v(_vm._s(_vm.$t("service_explain")))]
          ),
          _vm.loading === true
            ? _c("el-load-icon", { staticClass: "loading-icon" })
            : _c(
                "el-button",
                {
                  staticClass: "button-style",
                  attrs: { "max-width": _vm.maxWidth, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.chooseId("register")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("i_am_service")) + "\n      "
                  ),
                ]
              ),
        ],
        1
      ),
      _vm.getCountryOrRegionIndex() !== 23
        ? _c(
            "div",
            { staticClass: "service-card margin-top" },
            [
              _c("div", { staticClass: "pic2" }),
              _c("span", { staticClass: "text1" }, [
                _vm._v(_vm._s(_vm.$t("account_type_4"))),
              ]),
              _c(
                "span",
                {
                  staticClass: "text-style text2",
                  attrs: {
                    id: "text2_1",
                    title: _vm.$t("account_type_4_explain"),
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("account_type_4_explain")) +
                      "\n      "
                  ),
                ]
              ),
              _vm.loading === true
                ? _c("el-load-icon", { staticClass: "loading-icon" })
                : _c(
                    "el-button",
                    {
                      staticClass: "button-style",
                      attrs: { "max-width": _vm.maxWidth, type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.chooseId("endUserId")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("i_am_account_type_4")) +
                          "\n      "
                      ),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }